import App from './App.svelte';
import { writable, derived } from 'svelte/store';


export const apiData = writable([]);

const app = new App({
	target: document.body,
	props: {
		name: 'world blablabla'
	}
});

export const companyNames = derived(apiData, ($apiData) => {
  if ($apiData.companies){
    return $apiData.companies.map(company => company.display_name);
  }
  return [];
});

export default app;
